<template>
  <div class="data-table sticky">
    <v-table
      :title="title"
      :columns="columns"
      :rows="rows"
      :total="total"
      :page="page"
      :page-size="pageSize"
      :sortable="sortable"
      :is-slot-mode="isSlotMode"
      :is-hide-paging="true"
      :is-static-mode="isStaticMode"
      :has-checkbox="hasCheckbox"
      :messages="messages"
      class="text-sm text-cdp-black-500 duration-150"
      :class="{
        'opacity-30': isLoading
      }"
      @row-clicked="rowClick"
      @do-search="search"
    >
      <template v-for="(item, idx) in columns" #[item.field]="data" :key="`slot-${idx}`">
        <slot :name="item.field" :item="data.value">
          {{ data.value[item.field] }}
        </slot>
      </template>
    </v-table>
    <div
      v-if="total && !isHidePaging"
      class="flex w-full items-center justify-center gap-2 pb-4 pt-8"
    >
      <div class="text-sm text-cdp-black-300">共 {{ commonThousandths(total) }} 筆</div>
      <div>
        <paginations v-model="inPage" :total="total" :per-page="pageSize" />
      </div>
      <selects v-model="limit" :items="pageOptions" />
    </div>
    <div
      v-show="isLoading"
      class="absolute left-0 top-0 z-10 flex h-full w-full justify-center"
    />
  </div>
</template>

<script>
import { commonThousandths } from '@/composables/common.js';

import vueTableLite from 'vue3-table-lite';
import paginations from '@/components/Paginations.vue';

import { defineComponent, computed, toRaw } from 'vue';

export default defineComponent({
  name: 'DateTable',
  components: {
    vTable: vueTableLite,
    paginations
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    columns: {
      type: Array,
      default: () => [
        {
          isKey: {
            // 欄位是否為Key值
            type: Boolean,
            default: false
          },
          label: {
            // 欄位顯示於畫面的名稱
            type: String,
            default: ''
          },
          field: {
            // 欄位在資料中代表的名稱
            type: String,
            default: ''
          },
          width: {
            // 欄位在表格中佔有的畫面寬度
            type: String,
            default: ''
          },
          sortable: {
            // 欄位是否可以排序
            type: Boolean,
            default: false
          },
          display: {
            // 當你需要客製化顯示內容或二次處理時請定義該方法並返回HTML或字串等
            type: Function,
            default: null
          },
          headerClasses: {
            // 表頭(<th>)的Class（陣列格式）
            type: Array,
            default: () => []
          },
          columnClasses: {
            // 欄位(<td>)的Class（陣列格式）
            type: Array,
            default: () => []
          }
        }
      ]
    },
    rows: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    sortable: {
      type: Object,
      default: () => {
        return {
          order: {
            type: String,
            default: ''
          },
          sort: {
            type: String,
            default: ''
          }
        };
      }
    },
    isSlotMode: {
      type: Boolean,
      default: true
    },
    isStaticMode: {
      type: Boolean,
      default: false
    },
    isHidePaging: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    hasCheckbox: {
      type: Boolean,
      default: false
    },
    messages: {
      type: Object,
      default: () => {
        return {
          pagingInfo: '顯示 {0}-{1} 中的 {2} 筆',
          pageSizeChangeLabel: '顯示頁數',
          gotoPageLabel: '至',
          noDataAvailable: '尚無資料'
        };
      }
    },
    rowClasses: {
      type: Function || Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageOptions: {
      type: Array,
      default: () => [
        { value: 10, text: '10項 / 頁' },
        { value: 20, text: '20項 / 頁' },
        { value: 50, text: '50項 / 頁' }
      ]
    }
  },
  emits: ['update:sortable', 'update:page', 'update:pageSize', 'rowClicked', 'change'],
  setup(props, { emit }) {
    const inPage = computed({
      get: () => props.page,
      set: (val) => {
        emit('update:page', val);
      }
    });

    const limit = computed({
      get: () => props.pageSize,
      set: (val) => {
        emit('update:pageSize', val);
      }
    });

    function rowClick() {
      emit('rowClicked');
    }
    function search(offset, limit, order, sort) {
      if (props.sortable.order !== toRaw(order) || props.sortable.sort !== toRaw(sort)) {
        inPage.value = 1;
      }

      emit('update:sortable', {
        order,
        sort
      });

      emit('change', {
        offset,
        limit,
        order,
        sort
      });
    }
    return {
      commonThousandths,
      inPage,
      limit,
      rowClick,
      search
    };
  }
});
</script>